const namespace = 'moments/';

const SET_MOMENTS = namespace + 'set_moments';


export const REMOVE_MOMENT = namespace + 'remove_moment';
export const CLEAR_MOMENTS = namespace + 'clear_moments';
export const ADD_MOMENT = namespace + 'add_moment';
export const GET_MOMENTS = namespace + 'get_moments';


export default {
    state: {
        moments: {
            '2021-02-20': ['morning','afternoon']
        },
    },
    mutations: {
        [SET_MOMENTS](state, moments){
            //JSON Parse for reactivity
            state.moments = JSON.parse(JSON.stringify(moments));
        },
    },
    actions: {
        [CLEAR_MOMENTS]({commit}){
            commit(SET_MOMENTS, {});
        },
        [ADD_MOMENT]({commit, getters}, {key, times}){
            let moments = getters[GET_MOMENTS];
            moments[key] = times;
            commit(SET_MOMENTS, moments);
        },
        [REMOVE_MOMENT]({commit, getters}, key){
            let moments = getters[GET_MOMENTS];
            delete moments[key];
            commit(SET_MOMENTS, moments);
        }
    },
    getters: {
        [GET_MOMENTS]: (state) => state.moments,
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/moments.js